import { ArrangementType, TimeAlignment } from '../models/enums';
import { LayerViewModel } from '../view-models/layer-viewmodel';
import { ILayout, ITimeRange, ITraceViewModel } from '../models/interfaces';
import { ChangeDetectionComposer } from './changeDetectionComposer';

export class TimeAlignmentComposer extends ChangeDetectionComposer<TimeAlignment> {
    // constructor

    constructor(layout: ILayout) {
        super(layout, TimeAlignment.Simultaneous);
    }

    // public functions

    public isChanged() {
        return this.changeDetection.isChanged(this.layout.ecgState.chartState.timeAlignment);
    }

    // protected functions

    protected onUpdate(layer: LayerViewModel) {
        if (this.layout.ecgState.chartState.arrangement === ArrangementType.Medians) {
            layer.visibleTraces.forEach((trace) => {
                const samplesRange = { start: 0, end: trace.channel?.samples.length ?? 0 };
                this.updateTraceTimeAlignment(trace, samplesRange);
            });

            return;
        }

        switch (this.layout.ecgState.chartState.timeAlignment) {
            case TimeAlignment.Sequential:
                for (let column = 0; column < this.layout.columns; column++) {
                    for (let row = 0; row < this.layout.rows; row++) {
                        const trace = layer.visibleTraces[column * this.layout.rows + row];
                        if (!trace) {
                            continue;
                        }
                        const numberOfSamples = trace.channel?.samples.length ?? 0;
                        let samplesRange = {
                            start: (column * numberOfSamples) / this.layout.columns,
                            end:
                                (column * numberOfSamples) / this.layout.columns +
                                numberOfSamples / this.layout.columns,
                        };
                        this.updateTraceTimeAlignment(trace, samplesRange);
                    }
                }

                layer.referenceTraces.forEach((trace) => {
                    const numberOfSamples = trace.channel?.samples.length ?? 0;
                    this.updateTraceTimeAlignment(trace, { start: 0, end: numberOfSamples });
                });
                // let referenceTrace = layer.traces[layer.traces.length - 1];
                // if (referenceTrace) {
                //     this.updateTraceTimeAlignment(referenceTrace, { start: 0, end: referenceTrace.channel.samples.length });
                // }

                break;
            default:
                layer.visibleTraces.forEach((trace) => {
                    const numberOfSamples = trace.channel?.samples.length ?? 0;
                    const samplesRange = { start: 0, end: numberOfSamples / this.layout.columns };
                    this.updateTraceTimeAlignment(trace, samplesRange);
                });
                break;
        }
    }

    private updateTraceTimeAlignment(trace: ITraceViewModel, range: ITimeRange) {
        trace.updateTraceTimeAlignment(range);
    }
}
